<template>
  <div>
    <div class="warp">
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('bsl')" class="img1" alt="" src="../../assets/img/appointment.png">
        </div>
        <p class="p1">伯思立预约</p>
      </div>
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('fls')" class="img1" alt="" src="../../assets/img/appointment.png">
        </div>
        <p class="p1">翡立思预约</p>
      </div>
      <div class="left" v-if="flag">
        <div class="circle">
          <img @click="sc('ntbsl')" class="img1" alt="" src="../../assets/img/appointment.png">
        </div>
        <p class="p1">南通伯思立</p>
      </div>
      <div class="left" v-if="scan">
        <div class="circle">
          <img @click="cy" class="img2" alt="" src="../../assets/img/part.png">
        </div>
        <p class="p1">扫码管理</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "system",
  data() {
    return {
      systemType: JSON.parse(localStorage.getItem('userInfo')).systemType,
      flag: true,
      scan: true,
      cityCode: JSON.parse(localStorage.getItem('userInfo')).cityCode,
    }
  },
  created() {
    if (this.systemType.indexOf('2') != -1 && this.systemType.indexOf('1') != -1) {
      this.flag = true
      this.scan = true
    } else {
      this.flag = true
      this.scan = false
    }
  },
  methods: {
    sc(val) {
      if (this.cityCode == '1' && val == 'ntbsl') {
        this.$toast.fail('此账号没有权限');
      } else if (this.cityCode == '2' && (val == 'bsl' || val == 'fls')) {
        this.$toast.fail('此账号没有权限');
      } else {
        this.$router.replace("/index");
        localStorage.setItem('sysType', 'supermarket')
        localStorage.setItem('areaType', val)
      }
    },
    cy() {
      this.$router.replace("/list");
      localStorage.setItem('sysType', 'catering')

    },
  }
}
</script>

<style scoped>
.warp {
  padding-top: 50%;
  display: flex;
  flex-wrap: wrap;
}
.left {
  width: 50%;
  cursor: pointer;
  text-align: center;
}
.circle {
  margin: auto;
  border-radius: 30%;
  width: 80px;
  height: 80px;
  background: #379aee;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img1 {
  display: block;
  width: 60px;
  height: 60px;
}
.img2 {
  display: block;
  width: 60px;
  height: 60px;
}
.p1 {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/system.vue